import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'message-modal',
    templateUrl: 'message-modal.component.html'
})
export class MessageModal {
    private dialogRef = inject<MatDialogRef<MessageModal>>(MatDialogRef);
    private data = inject(MAT_DIALOG_DATA);

    headerTitle = this.data.headerTitle;
    message = this.data.message;
    okText = this.data.okText != null ? this.data.okText : "Ok";

    onOkClick() {
        this.dialogRef.close();
    }
}
